exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page__header{position:fixed;top:0;left:0;width:100%;padding-top:50px;padding-bottom:40px;background-color:hsla(0,0%,95.3%,.6);transition:all .3s ease;z-index:2}.page__header.-min{opacity:0!important;transform:translateY(-100%)!important}@media (max-width:834px){.page__header{padding:30px 16px 25px}}.page__header .back i{margin-right:12px}.page__header .back:hover{color:#fbba14}", ""]);

// exports
